import Swiper from "swiper/bundle"

export function swiperinit() {
    let trim = document.querySelector(".trimmingBtn")

    var swiper = new Swiper(".mySwiper", {
        spaceBetween: 15,
        slidesPerView: "auto",
        breakpoints: {
            1025: {
                spaceBetween: 40,
            }
        }
    });

    let newnewsSwiper = new Swiper(".newnewsSwiper", {
        slidesPerView: "auto",
        centeredSlides: true,
        breakpoints: {
            1025: {
                centeredSlides: false,
            },
        }
    });

    if (window.innerWidth <= 1024) {
        var swiper4sp = new Swiper(".swiper4sp", {
            spaceBetween: 15,
        });

        var facisSwiper4sp = new Swiper(".facisSwiper4sp", {
            spaceBetween: 15,
        });

        if (location.hash == "#trimming") {
            trimSwiper()
        }
    }

    //trimming動作条件
    trim.removeEventListener("click", trimEvent)
    if (location.pathname == "/facility") {
        trim.addEventListener("click", trimEvent)
    }

    function trimSwiper() {
        if (window.innerWidth <= 1024) {
            let facisTgt = document.querySelector("#trimming")
            let facisElms = document.querySelectorAll(".facis__innerCellsInnerCell")
            let targetNum = [].slice.call(facisElms).indexOf(facisTgt);
            facisSwiper4sp.slideTo(targetNum + 1)
        }
    }

    function trimEvent() {
        document.querySelector(".header").classList.remove("is-on")
        document.documentElement.style.overflowY = "auto"
        trimSwiper()
    }
}

{
    /* <div class="swiper mySwiper">
        <div class="swiper-wrapper">
            <div class="swiper-slide"
                <figure>
                    <img src="" alt="" />
                </figure>
            </div>
        </div>
    </div> */

    // @import '../../node_modules/swiper/swiper-bundle.min.css';

}